import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div>
      {/* Hero Section */}
      <section style={styles.hero}>
        <div style={styles.heroOverlay}>
          <div style={styles.container}>
            <h1 style={styles.heroTitle}>
               <span style={{color: '#FFABC8'}}>Empower Your Body</span>
              <br /> <span style={{color: '#1A5632'}}>Elevate Your Spirit</span>
            </h1>
            <p style={styles.heroSubtitle}>
              Join GlowFlex Sisters Club - Where fitness meets sisterhood
            </p>
            <div style={styles.heroCTA}>
              <Link to="/activities">
                <button className="btn btn-primary" style={{marginRight: '1rem'}}>Browse Activities</button>
              </Link>
              <Link to="/register">
                <button className="btn btn-secondary">Join Now</button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section style={styles.section}>
        <div style={styles.container}>
          <h2 style={styles.sectionTitle}>Welcome to GlowFlex</h2>
          <p style={styles.sectionText}>
            We're a women-focused fitness community offering group classes, sports sessions, 
            monthly adventures, and a healthy cafe. Empowering sisters through movement!
          </p>
        </div>
      </section>

      {/* Activities Preview */}
      <section style={styles.section}>
        <div style={styles.container}>
          <h2 style={styles.sectionTitle}>What We Offer</h2>
          
          <div style={styles.grid}>
            <div style={styles.card}>
              <div style={styles.imageContainer}>
                <img src="/images/fitness-class.jpg" alt="Fitness Classes" style={styles.cardImage} />
              </div>
              <h3 style={{color: '#1A5632', marginBottom: '1rem'}}>Fitness Classes</h3>
              <p style={styles.cardText}>Zumba, Yoga, Pilates, Aerobics, Spin, Swimming & more!</p>
              <p style={styles.schedule}>Every Saturday & Sunday</p>
            </div>

            <div style={styles.card}>
              <div style={styles.imageContainer}>
                <img src="/images/sports.jpg" alt="Sports Sessions" style={styles.cardImage} />
              </div>
              <h3 style={{color: '#1A5632', marginBottom: '1rem'}}>Sports Sessions</h3>
              <p style={styles.cardText}>Football, Volleyball, Basketball </p>
              <p style={styles.schedule}>Every Wednesday and Thursday Evening</p>
            </div>

            <div style={styles.card}>
              <div style={styles.imageContainer}>
                <img src="/images/events.jpg" alt="Monthly Events" style={styles.cardImage} />
              </div>
              <h3 style={{color: '#1A5632', marginBottom: '1rem'}}>Monthly Events</h3>
              <p style={styles.cardText}>Hiking, Horse Riding, Running and Archery Adventures</p>
              <p style={styles.schedule}>Special Monthly Experiences</p>
            </div>

            <div style={styles.card}>
              <div style={styles.imageContainer}>
                <img src="/images/cafe.jpg" alt="Healthy Cafe" style={styles.cardImage} />
              </div>
              <h3 style={{color: '#1A5632', marginBottom: '1rem'}}>Healthy Cafe</h3>
              <p style={styles.cardText}>Matcha drinks, Acai bowls, Fresh sandwiches & more</p>
              <p style={styles.schedule}>Fuel Your Fitness</p>
            </div>
          </div>

          <div style={{textAlign: 'center', marginTop: '3rem'}}>
            <Link to="/activities">
              <button className="btn btn-primary" style={{fontSize: '1.1rem', padding: '1rem 3rem'}}>View All Activities</button>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section - STYLISH WITH BACKGROUND */}
      <section style={styles.ctaSection}>
        <div style={styles.ctaOverlay}>
          <div style={styles.container}>
            <h2 style={styles.ctaTitle}>Ready to Start Your Journey?</h2>
            <p style={styles.ctaText}>
              Join hundreds of sisters transforming their lives through fitness
            </p>
            <div style={{textAlign: 'center'}}>
              <Link to="/register">
                <button style={styles.ctaButton}>
                  Sign Up Today →
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

const styles = {
  hero: {
    backgroundImage: 'url(/images/hero-bg.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '450px',
    position: 'relative',
    marginTop: '-1px'
  },
  heroOverlay: {
    background: 'transparent',
    minHeight: '450px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '3rem 0'
  },
  heroTitle: {
    fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
    marginBottom: '1.5rem',
    fontFamily: 'Playfair Display, serif',
    color: '#1a5632',
    fontWeight: 800,
    textShadow: '2px 2px 4px rgba(255,255,255,0.8)',
    lineHeight: 1.2
  },
  heroSubtitle: {
    fontSize: '1.4rem',
    color: '#1a5632',
    marginBottom: '2.5rem',
    fontWeight: 600,
    textShadow: '1px 1px 2px rgba(255,255,255,0.8)'
  },
  heroCTA: {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  section: {
    padding: '5rem 0',
    background: '#FAFAFA'
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '0 2rem'
  },
  sectionTitle: {
    fontSize: 'clamp(2.5rem, 4vw, 3.5rem)',
    textAlign: 'center',
    marginBottom: '1rem',
    fontFamily: 'Playfair Display, serif',
    color: '#1a5632'
  },
  sectionText: {
    fontSize: '1.2rem',
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto 4rem',
    color: '#1a5632',
    lineHeight: 1.8
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '2.5rem',
    marginTop: '3rem'
  },
  card: {
    background: 'white',
    padding: '2rem',
    borderRadius: '20px',
    boxShadow: '0 4px 20px rgba(227, 116, 187, 0.36)',
    textAlign: 'center',
    transition: 'transform 0.3s, box-shadow 0.3s',
    cursor: 'pointer',
    border: '1px solid rgba(0,0,0,0.05)'
  },
  imageContainer: {
    width: '100%',
    height: '220px',
    marginBottom: '1.5rem',
    borderRadius: '15px',
    overflow: 'hidden',
    background: 'linear-gradient(135deg, rgba(255,168,185,0.2), rgba(122,184,69,0.2))'
  },
  cardImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'transform 0.3s'
  },
  cardText: {
    color: '#1a5632',
    lineHeight: 1.6,
    marginBottom: '1rem',
    fontSize: '1rem'
  },
  schedule: {
    color: '#1a5632',
    fontWeight: 600,
    marginTop: '1rem',
    fontSize: '0.95rem'
  },
  ctaSection: {
    backgroundImage: 'url(/images/cta-bg.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    margin: 0,
    padding: 0
  },
  ctaOverlay: {
    background: 'transparent',
    padding: '6rem 0',
    textAlign: 'center'
  },
  ctaTitle: {
    color: 'pink',
    fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
    marginBottom: '1.5rem',
    fontFamily: 'Playfair Display, serif',
    fontWeight: 800,
    textShadow: '2px 2px 8px rgba(0,0,0,0.3)'
  },
  ctaText: {
    color: 'pink',
    fontSize: '1.4rem',
    marginBottom: '3rem',
    fontWeight: 500,
    textShadow: '1px 1px 4px rgba(0,0,0,0.2)'
  },
  ctaButton: {
    background: '#ffabc8',
    color: '#1a5632',
    padding: '1.3rem 4rem',
    fontSize: '1.2rem',
    fontWeight: 700,
    border: 'none',
    borderRadius: '50px',
    boxShadow: '0 6px 30px rgba(0,0,0,0.25)',
    transition: 'all 0.3s',
    textTransform: 'uppercase',
    letterSpacing: '1.5px'
  }
};

export default Home;